"use client";

import type React from "react";
import type { FooterBottomData } from "@/types";

export interface FooterBottomProps {
  bottomData: FooterBottomData;
}

const FooterBottom: React.FC<FooterBottomProps> = ({ bottomData }) => {
  const { bottomInfo } = bottomData;

  return (
    <div className="pt-8 border-t border-black/10 mt-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-8 text-sm text-black/60">
          <span>{bottomInfo.established}</span>
          <div className="w-1 h-1 bg-black/30 rounded-full"></div>
          <span>{bottomInfo.tradition}</span>
          <div className="w-1 h-1 bg-black/30 rounded-full"></div>
          <span>{bottomInfo.location}</span>
        </div>
        <div className="text-sm text-black/60">{bottomInfo.fullCopyright}</div>
      </div>
    </div>
  );
};

export default FooterBottom;
